export default __webpack_public_path__ + "static/media/third.42a88610.png";